import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const CLEAR = 'CLEAR';
export const consts = createReqConsts('circles', 'leaveFamilyCircle', [CLEAR]);
export const actions = createActions(consts);

export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'delete',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'family_members',
    {
      type: 'payload',
      selector: ['memberId'],
    },
  ],
});

const requestReducer = createReqReducer(consts);

const clear = state => ({
  ...state,
  succeed: null,
  error: null,
});

export default (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case consts.CLEAR:
      return clear(state);

    default:
      return requestReducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/circles/leaveFamilyCircle.js